import { render, staticRenderFns } from "./FileGallery.vue?vue&type=template&id=244e4929&scoped=true&"
import script from "./FileGallery.vue?vue&type=script&lang=ts&"
export * from "./FileGallery.vue?vue&type=script&lang=ts&"
import style0 from "./FileGallery.vue?vue&type=style&index=0&id=244e4929&scoped=true&lang=css&"
import style1 from "./FileGallery.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244e4929",
  null
  
)

export default component.exports